import MaterialTable from 'material-table';
import React, { useContext, useState } from 'react';
import { defaultGridOptions, useGridColDefs, tooltipDelay } from '../../utils/GridUtils';
import { FindInPage, Search } from '@material-ui/icons';
import DialogAcerBrag from '../../components/UI/DialogAcerBrag';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import FileDownloaderAcerBrag from '../../components/UI/FileDownloaderAcerBrag';
import { centeredCell } from '../../constants/StyleConstants';
import purchaseOrdersApi from '../../services/purchaseOrdersApi';
import { AppContext } from '../../contexts/AppContext';
import { LoginContext } from '../../contexts/LoginContext';
import { decodeFile } from '../../utils/MiscellaneousUtils';
import PurchaseOrderDetailModal from './PurchaseOrderDetailModal';

const useStyles = makeStyles(theme => ({ centeredCell }));

const PurchaseOrdersGrid = ({ data, onRowClick, loading }) => {
  const classes = useStyles();
  const { showError } = useContext(AppContext);
  const { isAllowedByRole } = useContext(LoginContext);
  const [open, setOpen] = useState(false);
  const [purchaseOrderNumber, setPurchaseOrderNumber] = useState(null);
  const [cuit, setCuit] = useState(null);
  const [openDetailDialog, setOpenDetailDialog] = useState(false);

  const handleDownloadFile = (value, e) => {
    onRowClick && e.stopPropagation();

    purchaseOrdersApi
      .getFile(btoa(value))
      .then(res => decodeFile(res, 'OrdenDeCompra.pdf'))
      .catch(error => showError('Error al descargar archivo'));
  };

  const handleViewDetails = (e, rowData) => {
    onRowClick && e.stopPropagation();

    setPurchaseOrderNumber(rowData.purchaseOrderCode);
    setCuit(rowData.Cuit);
    setOpenDetailDialog(true);
  };

  const colDefs = useGridColDefs([
    { title: 'Nro. Pedido de compra', field: 'purchaseOrderCode' },
    { title: 'Fecha de pedido', field: 'purchaseOrderDate', valueType: 'date' },
    //TODO: Descomentar este bloque cuando ACERBRAG pueda solucionar el alojamiento de archivos para esta funcionalidad
    // {
    //   title: 'Descarga de pdf',
    //   field: 'urlPdfPurchaseOrder',
    //   sorting: false,
    //   valueType: 'icon',
    //   valueRender: (value, rowData) => {
    //     return (
    //       <Tooltip
    //         title={value !== '' ? 'Ver adjuntos' : 'No se encontraron adjuntos'}
    //         enterDelay={tooltipDelay}
    //         enterNextDelay={tooltipDelay}>
    //         <span>
    //           <IconButton
    //             disabled={value === ''}
    //             aria-label="visualizar"
    //             size="small"
    //             color="primary"
    //             onClick={e => isAllowedByRole() && handleDownloadFile(value, e)}>
    //             <FindInPage />
    //           </IconButton>
    //         </span>
    //       </Tooltip>
    //     );
    //   },
    // },
    {
      title: 'Ver detalle',
      field: 'actions',
      sorting: false,
      valueType: 'icon',
      valueRender: (value, rowData) => (
        <div className={classes.centeredCell}>
          <Tooltip title="Ver detalle" enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
            <IconButton aria-label="visualizar" size="small" color="primary" onClick={e => handleViewDetails(e, rowData)}>
              <Search />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ]);

  return (
    <>
      <DialogAcerBrag open={open} setOpen={setOpen} title="Documentos">
        <FileDownloaderAcerBrag data={[1, 2, 3]} action={e => setOpen(false)} />
      </DialogAcerBrag>
      <PurchaseOrderDetailModal
        open={openDetailDialog}
        setOpen={setOpenDetailDialog}
        cuit={cuit}
        purchaseOrderNumber={purchaseOrderNumber}
      />
      <MaterialTable {...defaultGridOptions} columns={colDefs} data={data} onRowClick={onRowClick} isLoading={loading} />
    </>
  );
};

export default PurchaseOrdersGrid;
